import { useSelector } from "react-redux";
import Details from "./Details";
import classes from "./Details.module.css";
import EllipseButton from "../../../components/UI/Buttons/EllipseButton/EllipseButton";
import MessagingAccordion from "../../../components/UI/Accordion/MessagingAccordion/MessagingAccordion";
import Strings from "../../../resources/Strings";
import store from "../../../redux/Store";
import { commonActions } from "../../../redux/reducers/CommonReducer";
import AddCampaignForm from "../../../components/UI/Forms/Wizard Forms/AddForms/AddCampaignForm";
import { ADD_CAMPAIGN_FORM_STEPS } from "../../../enums/Enums";
import MessagingRecipientsContentCard from "../../../components/UI/Cards/MessagingContentCard/MessagingRecipientsContentCard";
import MessagingParkersContentCard from "../../../components/UI/Cards/MessagingContentCard/MessagingParkersContentCard";
import CampaignInfoContentCard from "../../../components/UI/Cards/MessagingContentCard/CampaignInfoContentCard";
import { LENGTHS } from "../../../config/Config";

const MessagingDetails = (props) => {
  const messagingHistories = useSelector((state) => state.messaging.messagingHistoriesData?.messagingHistories);
  const siteDisplayName = props?.site?.[0]?.displayName;

  // Gets the last known messaging history of the campaign
  // on campaign table compare with props?.id, else with props?.campaignId
  const foundedCampaignMessagingHistory = messagingHistories?.filter(mh => mh?.campaignId === (props?.tableName === Strings.TABS_NAMES.CAMPAIGNS ? props?.id : props?.campaignId)).sort((a, b) => new Date(b.dateSent) - new Date(a.dateSent))?.[0];

  // If opened from campaigns take user from foundedCampaignMessagingHistory else (messaging history / mailing list, use props?.user)
  // sended user (messaging history tab ) / created user (mailing lists tab)
  //const foundedUser = props?.tableName === Strings.TABS_NAMES.CAMPAIGNS && foundedCampaignMessagingHistory ? foundedCampaignMessagingHistory?.user : props?.user;
  
  // always take user from props.user
  const foundedUser = props?.user;

  const openRecipientsStep = () => {
    store.dispatch(commonActions.setSideModal({ modalContent: <AddCampaignForm currentStep={ADD_CAMPAIGN_FORM_STEPS.RECIPIENTS} campaign={props} isReview={true} />}));
  };

  const getDetailsContent = () => {
    switch (props?.tableName) {
      case Strings.TABS_NAMES.CAMPAIGNS:
        return (
          <>
            {/* if campaign was sent show sent details (from messaging history), if not show created details*/}
            {/* {foundedCampaignMessagingHistory !== undefined ? 
              <MessagingAccordion 
                outerTitle={Strings.DETAILS}
                expanded={true}
                detailsData={[
                  {title: `${Strings.SENT_BY}`, value: `${Strings.NAME_IN_SITE.format(`${foundedUser?.firstName} ${foundedUser?.lastName}`, siteDisplayName)}`},
                  {title: `${Strings.DATE_SENT}`, value: foundedCampaignMessagingHistory?.dateSent},
                  {title: `${Strings.TOTAL}`, value: `$ ${parseFloat(foundedCampaignMessagingHistory?.total).toFixed(LENGTHS.TO_FIXED_LENGTH)}`},
                ]}           
                {...props}
              />
              :
              <MessagingAccordion 
                outerTitle={Strings.DETAILS}
                expanded={true}
                detailsData={[               
                  {title: `${Strings.DATE_CREATED}`, value: props?.createdDate},
                ]}           
                {...props}
              />
            } */}
            
            <MessagingAccordion 
              outerTitle={Strings.DETAILS}
              expanded={true}
              detailsData={[
                {title: `${Strings.CREATED_BY}`, value: `${Strings.NAME_IN_SITE.format(`${foundedUser?.firstName} ${foundedUser?.lastName}`, siteDisplayName)}`}, 
                {title: `${Strings.DATE_CREATED}`, value: props?.createdDate},
              ]}
              {...props}
            />
          
            <div className={classes.sendCampaignContainer}>
              <div className={classes.detailsContainer}>
                    <div className={classes.detailsAccordion}>
                        <div>{Strings.READY_TO_SEND_CAMPAIGN}</div>  
                        <h6>{Strings.READY_TO_SEND_CAMPAIGN_MESSAGE}</h6>                       
                        <div className={classes.next}>
                          <EllipseButton type="button" onClick={openRecipientsStep}>{Strings.REVIEW_SEND_CAMPAIGN}</EllipseButton>
                        </div>
                    </div>
              </div>
            </div>   
          </>
        );

      case Strings.TABS_NAMES.MESSAGING_HISTORY:
        return (
          <>
            <MessagingAccordion 
              outerTitle={Strings.DETAILS}
              expanded={true}
              detailsData={[
                {title: `${Strings.SENT_BY}`, value: `${Strings.NAME_IN_SITE.format(`${foundedUser?.firstName} ${foundedUser?.lastName}`, siteDisplayName)}`},
                {title: `${Strings.DATE_SENT}`, value: props?.dateSent},
                {title: `${Strings.TOTAL}`, value: `$ ${parseFloat(foundedCampaignMessagingHistory?.total).toFixed(LENGTHS.TO_FIXED_LENGTH)}`},
              ]}
              {...props}
            />
            {/* Show campaignInfo data if exists */}
            {(props?.campaignInfo !== null && props?.campaignInfo !== undefined) && (
              <MessagingAccordion 
                expanded={true}
                outerTitle={Strings.CAMPAIGN_DETAILS}
                contentCard={<CampaignInfoContentCard {...props} />}
                {...props}
              />
            )}

            {props?.recipients?.length > 0 && 
              <MessagingAccordion 
                outerTitle={Strings.RECIPIENTS}
                expanded={true}
                contentCard={<MessagingRecipientsContentCard {...props} />}
                {...props}
              />
            }
          </>
        );

      case Strings.TABS_NAMES.MAILING_LISTS:
        return (
          <>
            <MessagingAccordion 
              outerTitle={Strings.DETAILS}
              expanded={true}
              detailsData={[
                {title: `${Strings.CREATED_BY}`, value: `${Strings.NAME_IN_SITE.format(`${foundedUser?.firstName} ${foundedUser?.lastName}`, siteDisplayName)}`}, 
                {title: `${Strings.DATE_CREATED}`, value: props?.dateCreated},
              ]}
              {...props}
            />

            <MessagingAccordion 
              outerTitle={Strings.PARKERS}
              expanded={true}
              contentCard={<MessagingParkersContentCard {...props} />}
              {...props}
            />
          </>
        );

      default:
    }
  };

  return (
    <Details {...props}>
      {props && getDetailsContent()}
    </Details>
  );
};

export default MessagingDetails;
